import { styled } from "@linaria/react"

import * as textStyles from "@/styles/textStyles.ts"

// Same as tab style
const MaybeSelected = styled.span<{
  selected: boolean
}>`
  ${textStyles.smallFontSize};

  display: inline-flex;
  align-items: center;
  height: 32px;

  color: ${props => props.selected ? "var(--text-color)" : "var(--secondary-text-color)"};
  border-bottom: 1px solid ${props => props.selected ? "var(--text-color-20)" : "transparent"};
  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--text-color);
    border-bottom: 1px solid var(--text-color-20);
  }
`

export default MaybeSelected
